import * as actionTypes from "../actionTypes/documentRightsActionTypes";
import api from "../../api/documentRightsApi";
import { sendHttpRequest } from "actions/actionCreators/httpActions";
import { showError } from "actions/actionCreators/snackbarActions";
import { getDocumentRightsByStateKey } from "constants/common";
import { camelizeKeys } from "humps";

export function loadDocumentRights(documentId, siteId, stateId, documentTypeId) {
  return async (dispatch, getState) => {
    try {
      const stateKey = getDocumentRightsByStateKey(stateId, documentTypeId);
      if (getState().documentRights[stateKey]?.isLoaded) return;

      let response = await dispatch(sendHttpRequest(api.loadDocumentRights(documentId, siteId, documentTypeId)));

      const result = response.documentRights.reduce(
        (prev, right) => ({
          ...prev,
          [right.code.toLowerCase()]: right.hasRight
        }),
        {}
      );

      const camelizedJson = camelizeKeys(result);

      dispatch({ type: actionTypes.LOAD_DOCUMENT_RIGHTS_SUCCESS, payload: { stateKey, rights: camelizedJson } });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
    }
  };
}
